import { ENDPOINTS } from "../../../../legacy/network/endpoints";

export const TRANSACTION_ENDPOINTS = {
  ALL: ENDPOINTS.ALL_TRANSACTIONS,
  ANALYTICS: ENDPOINTS.TRANSACTION_ANALYTICS,
  METRICS: ENDPOINTS.TRANSACTION_METRICS,
  SINGLE_TRANSACTION: (id: string) => ENDPOINTS.SINGLE_TRANSACTION(id),
  RECEIPT: (id: string) => `/v1/admin/transaction/${id}/receipt`,
} as const;

